import React from "react";

export default function HowItWorks() {
  return (
    <section className="section" id="how-it-works">
      <div className="container">
        <div className="section-heading">
          <span className="section-label">How It Works</span>
          <h2>A Simple and Clear Process</h2>
          <p>
            The service is designed to make document translation easy, clear and
            professional from the first enquiry to final delivery.
          </p>
        </div>

        <div className="steps-grid">
          <div className="step-card">
            <div className="step-number">1</div>
            <h3>Send Your Request</h3>
            <p>
              Contact us with your document type, language pair and any details
              about the purpose of the translation.
            </p>
          </div>

          <div className="step-card">
            <div className="step-number">2</div>
            <h3>Receive a Quote</h3>
            <p>
              You receive a clear response with the service details and the next
              step for your translation request.
            </p>
          </div>

          <div className="step-card">
            <div className="step-number">3</div>
            <h3>Translation in Progress</h3>
            <p>
              Your document is handled professionally with care, consistency and
              attention to detail.
            </p>
          </div>

          <div className="step-card">
            <div className="step-number">4</div>
            <h3>Final Delivery</h3>
            <p>
              The completed translation is delivered in a clear and professional
              format suitable for its intended use.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}